import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ResultOf } from '@graphql-typed-document-node/core';
import {
  CustomFieldControl,
  DataService,
  SharedModule,
} from '@vendure/admin-ui/core';
import { unique } from '@vendure/common/lib/unique';
import { FormGroup } from '@angular/forms';
import { Observable, pairwise, startWith } from 'rxjs';
import {
  BaseProduct,
  FacetValue,
  GetBaseProductsDocument,
} from '../../../gql/graphql';

@Component({
  selector: 'base-product-select-input',
  templateUrl: 'base-product-select-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule],
})
export class BaseProductSelectorInputComponent
  implements OnInit, CustomFieldControl
{
  @Input() readonly: boolean;
  @Input() formControl: FormControl;
  @Input() config: any;

  detailForm: FormGroup;
  baseProducts$: Observable<
    NonNullable<
      ResultOf<typeof GetBaseProductsDocument>['baseProducts']['items']
    >
  >;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.baseProducts$ = this.dataService
      .query(GetBaseProductsDocument)
      .mapSingle(a => a.baseProducts.items ?? []);

    this.formControl.valueChanges.pipe(startWith(null), pairwise()).subscribe({
      next: ([prev, next]: BaseProduct[]) => {
        if (prev) this.removeFacetValue(prev.facetValues);
        if (next) this.addFacetValue(next.facetValues);
      },
    });
  }

  removeFacetValue(facetValues: FacetValue[]) {
    const formGroup: any = this.formControl.parent?.parent;
    if (!formGroup) return;

    const currentFacetValueIds: string[] = formGroup.value.facetValueIds;

    const filtered = facetValues.reduce((s: string[], facet) => {
      s = s.filter(e => e != facet.id);
      return s;
    }, currentFacetValueIds);

    formGroup.patchValue({
      facetValueIds: unique(filtered),
    });
    formGroup.markAsDirty();
  }

  addFacetValue(facetValues: FacetValue[]) {
    const formGroup: any = this.formControl.parent?.parent;
    if (!formGroup) return;

    const currentFacetValueIds = formGroup.value.facetValueIds ?? [];
    formGroup.patchValue({
      facetValueIds: unique([
        ...currentFacetValueIds,
        ...facetValues.map(e => e.id),
      ]),
    });
    formGroup.markAsDirty();
  }

  //TODO adicionar calculo de lucro
  //TODO validar preço antes de enviar formulário
}
